/*!
 * modernizr v3.6.0
 * Build https://modernizr.com/download?-serviceworker-dontmin
 *
 * Copyright (c)
 *  Faruk Ates
 *  Paul Irish
 *  Alex Sexton
 *  Ryan Seddon
 *  Patrick Kettner
 *  Stu Cox
 *  Richard Herrera

 * MIT License
 */

const tests = [];

/**
 *
 * ModernizrProto is the constructor for Modernizr
 *
 * @class
 * @access public
 */

const ModernizrProto = {
  // The current version, dummy
  _version: "3.6.0",

  // Any settings that don't work as separate modules
  // can go in here as configuration.
  _config: {
    classPrefix: "",
    enableClasses: true,
    enableJSClass: true,
    usePrefixes: true
  },

  // Queue of tests
  _q: [],

  // Stub these for people who are listening
  on: function (test, cb) {
    // I don't really think people should do this, but we can
    // safe guard it a bit.
    // -- NOTE:: this gets WAY overridden in src/addTest for actual async tests.
    // This is in case people listen to synchronous tests. I would leave it out,
    // but the code to *disallow* sync tests in the real version of this
    // function is actually larger than this.
    const self = this;
    setTimeout(function () {
      cb(self[test]);
    }, 0);
  },

  addTest: function (name, fn, options) {
    tests.push({ name, fn, options });
  },

  addAsyncTest: function (fn) {
    tests.push({ name: null, fn });
  }
};

// Fake some of Object.create so we can force non test results to be non "own" properties.
let Modernizr = function () {};
Modernizr.prototype = ModernizrProto;

// Leak modernizr globally when you `require` it rather than force it here.
// Overwrite name so constructor name is nicer :D
Modernizr = new Modernizr();

/*!
{
"name": "ServiceWorker API",
"property": "serviceworker",
"notes": [{
  "name": "ServiceWorkers Explained",
  "href": "https://github.com/slightlyoff/ServiceWorker/blob/master/explainer.md"
}]
}
! */
/* DOC
ServiceWorkers (formerly Navigation Controllers) are a way to persistently cache resources to built apps that work better offline.
*/

Modernizr.addTest("serviceworker", "serviceWorker" in navigator);

/**
 * is returns a boolean if the typeof an obj is exactly type.
 *
 * @access private
 * @function is
 * @param {*} obj - A thing we want to check the type of
 * @param {string} type - A string to compare the typeof against
 * @returns {boolean}
 */

function is (obj, type) {
  return typeof obj === type;
}

const classes = [];

/**
 * Run through all tests and detect their support in the current UA.
 *
 * @access private
 */

function testRunner () {
  let featureNames;
  let feature;
  let aliasIdx;
  let result;
  let nameIdx;
  let featureName;
  let featureNameSplit;

  for (const featureIdx in tests) {
    if (tests.hasOwnProperty(featureIdx)) {
      featureNames = [];
      feature = tests[featureIdx];
      // run the test, throw the return value into the Modernizr,
      // then based on that boolean, define an appropriate className
      // and push it into an array of classes we'll join later.
      //
      // If there is no name, it's an 'async' test that is run,
      // but not directly added to the object. That should
      // be done with a post-run addTest call.
      if (feature.name) {
        featureNames.push(feature.name.toLowerCase());

        if (feature.options && feature.options.aliases && feature.options.aliases.length) {
          // Add all the aliases into the names list
          for (aliasIdx = 0; aliasIdx < feature.options.aliases.length; aliasIdx++) {
            featureNames.push(feature.options.aliases[aliasIdx].toLowerCase());
          }
        }
      }

      // Run the test, or use the raw value if it's not a function
      result = is(feature.fn, "function") ? feature.fn() : feature.fn;

      // Set each of the names on the Modernizr object
      for (nameIdx = 0; nameIdx < featureNames.length; nameIdx++) {
        featureName = featureNames[nameIdx];
        // Support dot properties as sub tests. We don't do checking to make sure
        // that the implied parent tests have been added. You must call them in
        // order (either in the test, or make the parent test a dependency).
        //
        // Cap it to TWO to make the logic simple and because who needs that kind of subtesting
        // hashtag famous last words
        featureNameSplit = featureName.split(".");

        if (featureNameSplit.length === 1) {
          Modernizr[featureNameSplit[0]] = result;
        } else {
          // cast to a Boolean, if not one already
          if (Modernizr[featureNameSplit[0]] && !(Modernizr[featureNameSplit[0]] instanceof Boolean)) {
            Modernizr[featureNameSplit[0]] = new Boolean(Modernizr[featureNameSplit[0]]);
          }

          Modernizr[featureNameSplit[0]][featureNameSplit[1]] = result;
        }

        classes.push((result ? "" : "no-") + featureNameSplit.join("-"));
      }
    }
  }
}

// Run each test
testRunner();

delete ModernizrProto.addTest;
delete ModernizrProto.addAsyncTest;

// Run the things that are supposed to run after the tests
for (let i = 0; i < Modernizr._q.length; i++) {
  Modernizr._q[i]();
}

// Leak Modernizr namespace
var Modernizr$1 = Modernizr;

export { Modernizr$1 as default };
